import {useNavigate} from 'react-router-dom';
import {
    Button,
} from '@mantine/core';
import {
    hideNotification,
    showNotification
} from '@mantine/notifications';
import {AiOutlineQuestionCircle} from 'react-icons/ai';
import {
    useEffect,
    useRef
} from 'react';

import {useHelpPromptTimer} from '../hooks/useHelpPromptTimer.ts';

const NOTIFICATION_ID = 'help-prompt-notification';

export const HelpPromptNotification = () => {
    const {
        visible,
        dismiss
    } = useHelpPromptTimer();
    const navigate = useNavigate();
    const navigateRef = useRef(navigate);
    navigateRef.current = navigate;

    useEffect(() => {
        if (!visible) {
            return;
        }

        console.debug('LOGIN APP. HELP PROMPT. SHOWING NOTIFICATION');

        const handleClick = () => {
            hideNotification(NOTIFICATION_ID);
            dismiss();
            navigateRef.current('/documentation');
        };

        showNotification({
                             id: NOTIFICATION_ID,
                             title: 'Having trouble signing in?',
                             message: (
                                 <Button variant="subtle" color="panasonic" size="xs" onClick={handleClick}
                                         my="sm"
                                         styles={{ label: { whiteSpace: 'normal', lineHeight: 1.5 } }}
                                         style={{ height: 'auto', padding: '6px 12px' }}>
                                     Visit the Help page for step-by-step instructions
                                 </Button>
                             ),
                             icon: <AiOutlineQuestionCircle/>,
                             color: 'panasonic',
                             autoClose: false,
                             onClose: dismiss,
                         });
    }, [visible]);

    return null;
};
